export interface ExportColumnsTypes {
  enableInputs?: boolean;
  products?: any[];
  translate_products?: any[];
  products_price?: any[];
  action?: string;
}

export const exportColumns: ExportColumnsTypes = {
  products: [
    { title: 'Sku', key: 'sku' },
    { title: 'Name', key: 'name' },
    { title: 'Stock', key: 'stock' },
    { title: 'Buy Price', key: 'price' },
    { title: 'Sell Price', key: 'seller_price' },
    { title: 'Discount', key: 'discount_price' },
  ],
  translate_products: [
    { title: 'Sku', key: 'sku' },
    { title: 'name', key: 'name' },
    { title: 'long description', key: 'long_description' },
  ],
  action: '',
};

export interface ExportExampleCSVTypes {
  products: ExportProductsCSVTypes[];
  translate_products?: ExportProductsTranslationCSVTypes[];
  products_price?: ExportProductsPriceCSVTypes[];
}

export const exportExampleList: ExportExampleCSVTypes = {
  products: [
    {
      sku: 'XXXX',
      name: 'XXXX-1',
      stock: '50',
      price: '5',
      seller_price: '5',
      discount_price: '2',
    },
    {
      sku: 'YYYY',
      name: 'YYYY-1',
      stock: '100',
      price: '6',
      seller_price: '4',
      discount_price: '1',
    },
    {
      sku: 'ZZZZ',
      name: 'ZZZZ-1',
      stock: '150',
      price: '50',
      seller_price: '50',
      discount_price: '22',
    },
  ],
  translate_products: [
    {
      id: 'XXXX',
      name: 'Product Name 1',
      long_description: 'Product description 1',
    },
    {
      id: 'XXXX',
      name: 'Product Name 2',
      long_description: 'Product description 2',
    },
    {
      id: 'XXXX',
      name: 'Product Name 3',
      long_description: 'Product description 3',
    },
  ],
  products_price: [
    {
      id: 'XXXX',
      sku: '11234512',
      name: 'Jones',
      ean: '11223344',
      seller: 'Big',
      rating: 10,
      cncode: '12345',
      stock: 100,
      purchase_price_net: 1000,
      price_net: 1200,
      discount_price_net: 1400,
      tvsh: 124,
    },
  ],
};

export interface ExportProductsCSVTypes {
  sku: string;
  name: string;
  stock: any;
  price: string;
  seller_price: string;
  discount_price: string;
}

export interface ExportProductsPriceCSVTypes {
  id: string;
  sku: string;
  ean: string;
  name: string;
  seller: string;
  rating: number;
  cncode: string;
  stock: any;
  purchase_price_net: number;
  price_net: number;
  discount_price_net: number;
  tvsh: number;
}

export interface ExportProductsTranslationCSVTypes {
  id: string;
  name: string;
  long_description: string;
}

export interface ProductImport {
  id: string;
  sku: string;
  product_number: string;
  name: string;
  ean: string;
  image: string;
  long_description: string;
  length: string;
  weight: string;
  width: string;
  height: string;
  price: string;
  stock: string;
  rating: string;
}

export interface TableColumns {
  products: any;
  translate_products: any;
  products_price: any;
}

export const tableColumns: TableColumns = {
  products: [
    {
      title: 'SKU',
      dataIndex: 'sku',
      key: 'sku',
    },
    {
      title: 'Product Number',
      dataIndex: 'product_number',
      key: 'product_number',
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'EAN',
      dataIndex: 'ean',
      key: 'ean',
    },
    {
      title: 'Image URL',
      dataIndex: 'image',
      key: 'image',
    },
    {
      title: 'Long Description',
      dataIndex: 'ean',
      key: 'ean',
    },
    {
      title: 'Length',
      dataIndex: 'length',
      key: 'length',
    },
    {
      title: 'Weight',
      dataIndex: 'weight',
      key: 'weight',
    },
    {
      title: 'Width',
      dataIndex: 'width',
      key: 'width',
    },
    {
      title: 'Height',
      dataIndex: 'height',
      key: 'height',
    },
    {
      title: 'Price',
      dataIndex: 'price',
      key: 'price',
    },
    {
      title: 'Stock',
      dataIndex: 'stock',
      key: 'stock',
    },
    {
      title: 'Rating',
      dataIndex: 'rating',
      key: 'rating',
    },
  ],
  translate_products: [
    {
      title: 'SKU',
      dataIndex: 'sku',
      key: 'sku',
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Long Description',
      dataIndex: 'long_description',
      key: 'long_description',
    },
  ],
  products_price: [ 
    {
      title: 'SKU',
      dataIndex: 'sku',
      key: 'sku',
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'EAN',
      dataIndex: 'ean',
      key: 'ean',
    },
    {
      title: 'Seller',
      dataIndex: 'seller',
      key: 'seller',
    },
    {
      title: 'Rating',
      dataIndex: 'rating',
      key: 'rating',
    },
    {
      title: 'CNCODE',
      dataIndex: 'cncode',
      key: 'cncode',
    },
    {
      title: 'Stock',
      dataIndex: 'stock',
      key: 'stock',
    },
    {
      title: 'Purchase Price',
      dataIndex: 'purchase_price',
      key: 'purchase_price',
    },
    {
      title: 'Price',
      dataIndex: 'price',
      key: 'price',
    }, 
    {
      title: 'Discount Price',
      dataIndex: 'discount_price',
      key: 'discount_price',
    },
    {
      title: 'TVSH',
      dataIndex: 'tvsh',
      key: 'tvsh',
    },
  ],
};
